/**
 * // TODO: separate into dedicated global contexts
 * - dashboard (panels and guided tour mode)
 *
 * ALSO PERHAPS:
 * - modals
 * - errors (separate, or just together with other modals)
 */

import React, { createContext, useContext, useReducer } from "react";
import { Panel } from "_shared/graphql";

type StateType = {
  dashboardPanels: Panel[]; // TODO: replace with api cache
};

type Action = "GET_PANELS";

const initialState: StateType = {
  dashboardPanels: [],
};

const StoreContext = createContext(
  {} as {
    state: StateType;
    dispatch: React.Dispatch<
      Partial<StateType> & {
        type: Action;
      }
    >;
  },
);

const reducer = (
  state: StateType,
  action: Partial<StateType> & { type: Action },
): StateType => {
  switch (action.type) {
    case "GET_PANELS":
      return { ...state, dashboardPanels: action.dashboardPanels! };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const StateProvider: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
